import Formsy , { addValidationRule }  from 'formsy-react'
import { priceDisplay } from 'helpers/price';
import React, { Component } from 'react'
import { Container, Dropdown, Grid, Header, Pagination, Segment, Table, Icon, Dimmer,Loader, Search} from 'semantic-ui-react';
import { getCategoryList } from 'services/Categories';
import { getMarkets, searchSubscribedSeller, getSaasMetrics, isSubscriptionSearchEnabled} from 'services/Manager';
import { getSubscriptionStatus } from 'services/SellerSubscription';
import moment from 'moment';
import './SaasMetricsContainer.less'
import { isValidCellNumber , isNotBlankString } from 'helpers/validation';
import subStatus from 'constants/SellerSubscriptionStatus';


const rowsPerPage = 20;

const initialState = {
    categories: [],
    subStatus: [],
    markets: [],
    marketListOriginal: [],
    currentCategoryValue: '',
    currentCategoryText: '',
    currentStatusValue: '',
    currentStatusText: '',
    currentMarketValue: '',
    currentMarketText: '',
    page: 1,
    saasMetrics: [],
    saasMetricsCount: 0,
    pageChange: false,
    selectedSellerID:0,
    selectedSellerName : "",
    searchSellerName:"",
    searchSellerID:0,
    searchTerm: "",
    searchSellerList: [],
    serviceRadiusValue:"",
    processingRequests: false,
    subscriptionSearchEnabled: false,
    columnSort: [
        { column: 'connect', direction: 'descending' },
        { column: 'images', direction: null },
        { column: 'quoted', direction: null },
        { column: 'booked', direction: null },
        { column: 'lastConnected', direction: null },
    ],
    currentSortColumn: 'connect'
};

class SaasMetricsContainer extends Component {

    constructor(props){
        super(props);
        this.state = initialState;
    }

    componentDidMount(){
        console.log(this.state.columnSort)
        const subStatusPromise = getSubscriptionStatus();
        const categoryPromoise = getCategoryList();
        const marketPromise = getMarkets();
        const subsSearchPromise =  isSubscriptionSearchEnabled();
        Promise.all([subStatusPromise, categoryPromoise, marketPromise, subsSearchPromise]).then(([subStatusRes, categoryRes, marketRes, subsSearchRes]) => {
            const categoryList = this.populateCategories(categoryRes.data);
            const statusList = this.populateSubscriptionStatus(subStatusRes.data);
            const marketList = this.populateMarkets(marketRes.data);

            this.setState({
                categories: categoryList, 
                currentCategoryText: 'All Categories', 
                currentCategoryValue: '',
                subStatus: statusList, 
                currentStatusText: 'Active', 
                currentStatusValue: 'Active',
                markets: marketList, 
                marketListOriginal: marketRes.data,
                currentMarketText: 'Any Market', 
                currentMarketValue: '',
                processingRequests: false,
                subscriptionSearchEnabled: subsSearchRes.data.enabled
            }, () => {
                this.onSearch();
            });
        });
    }

    populateCategories = (categories) => {
        let categoryList = _.map(categories, cat => {
            return {value: cat.seoName, text: cat.name}
        });

        categoryList = [{value: '', text: 'All Categories'}, ...categoryList];
        return categoryList;
    }

    populateSubscriptionStatus = (status) => {

        status = _.filter(status, st => st.name != 'Suspended' && st.name != subStatus.DISPUTED && st.name != subStatus.PAYMENT_FAILED && st.name != subStatus.PENDING_ACTIVATION /*&& st.name != 'Cancelled'*/)
        let statusList = _.map(status, st => {
            return {value: st.name, text: st.name}
        });

        statusList = [{value: '', text: 'Any Status'}, ...statusList];
        return statusList;
    }

    populateMarkets = (markets) => {
        let marketList = _.map(markets, market => {
            return {value: market.marketID, text: market.name}
        });

        marketList = [{value: '', text: 'Any Market'}, ...marketList];
        return marketList;
    }

    onCategoryChange = (e, data) => {
        const selectedCategory = _.first(_.filter(this.state.categories, item => item.value == data.value));
        this.setState({currentCategoryValue: selectedCategory.value, currentCategoryText: selectedCategory.text})
    }

    onStatusChange = (e, data) => {
        const selectedStatus = _.first(_.filter(this.state.subStatus, item => item.value == data.value));
        this.setState({currentStatusValue: selectedStatus.value, currentStatusText: selectedStatus.text})
    }

    onMarketChange = (e, data) => {
        const selectedMarket = _.first(_.filter(this.state.markets, item => item.value == data.value));
        this.setState({currentMarketValue: selectedMarket.value, currentMarketText: selectedMarket.text})
    }

    onSearch = async (e, data) => {
        this.search();
    }

    search = async () => {
        this.setState({processingRequests: true}, async () => {
            const sortColumn = _.find(this.state.columnSort, x=>x.column == this.state.currentSortColumn);
            const saasMetricsRes = await getSaasMetrics(this.state.page, rowsPerPage, this.state.currentCategoryValue, this.state.currentStatusValue, this.state.currentMarketValue , this.state.searchSellerID, sortColumn.column, sortColumn.direction);
            this.setState({saasMetrics: saasMetricsRes.data.saasMetrics, saasMetricsCount: saasMetricsRes.data.saasMetricsCount, processingRequests: false});
        });
        this.setState({pageChange: false});
    }

    onPageChange = (e, data) => {
        this.setState({page: data.activePage, pageChange: true}, () => {
            this.search();
        });
        
    }   

    onSearchSellerChange = (e, data) => {
        this.setState({ searchSellerName: data.value })
        if (this.searchSellerTimer) {
            clearTimeout(this.searchSellerTimer);
        }

        this.setState({ searchTerm: data.value });

        this.searchSellerTimer = setTimeout(async () => {
            if (this.state.searchTerm.length > 0) {
                const res = await searchSubscribedSeller(this.state.searchTerm);
                if (res.resStatus == 200) {
                    const sellers = res.data;
                    const sellerList = _.map(sellers, s => {
                        return { title: s.name, id: s.sellerID }
                    });

                    this.setState({ searchSellerList: sellerList })

                }
            } else {
                this.setState({ searchSellerList: [] })
            }
        }, 600);
    }

    onSellerSelect = (e, data) => {
        this.setState({searchSellerID: data.result.id, searchSellerName: data.result.title});
    }

    resetSearch = () => {
        this.setState({searchSellerID: 0, searchSellerName: ''})
    }
    
    onTableSort = (columnName) => {
        
        const columnSort = [...this.state.columnSort];
        const column = _.find(columnSort, x => x.column == columnName);
        column.direction = (column.direction == null || column.direction == 'ascending') ? 'descending' : 'ascending';

        if (this.state.currentSortColumn != columnName) {
            const currentColumn = _.find(columnSort, x => x.column == this.state.currentSortColumn);
            currentColumn.direction = null;
            this.setState({ currentSortColumn: columnName });
        }
        this.setState({ pageChange: true, columnSort: columnSort }, () => {
            this.search();           
        });
    }  
    
    handleSellerNameClick = (sellerID) => {
        const win = window.open('/subscriptions/search/' + sellerID, "_blank");
        win.focus();
    }

    render() {
        return (
            <Dimmer.Dimmable as={Container} fluid className="active-subscription-container" dimmed={this.state.processingRequests}>
                <Dimmer active={this.state.processingRequests}>
                    <Loader size='massive'>Processing. Please Wait</Loader>
                </Dimmer>
                <div className="main-page-panel">
                    <div className="content-panel">
                        <div className="mobile-header">
                            <div className="main-heading">
                                SAAS Metrics
                            </div>
                        </div>
                        <Segment className="filter-segment">
                            <Formsy onValidSubmit={this.onSearch}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={16} className="search-container">
                                            <Header>Search Seller</Header>
                                            <Search fluid className='search' minCharacters={1} onSearchChange={this.onSearchSellerChange}
                                                results={this.state.searchSellerList} onResultSelect={this.onSellerSelect} value={this.state.searchSellerName} />
                                            <Icon name='delete' onClick={this.resetSearch} />
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                            <Header>Categories</Header>
                                            <Dropdown fluid name="category" key="act-sub-fil-category" 
                                            selection
                                            options={this.state.categories}
                                            value={this.state.currentCategoryValue}
                                            text={this.state.currentCategoryText}
                                            onChange={this.onCategoryChange}
                                            ></Dropdown>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                            <Header>Status</Header>
                                            <Dropdown fluid name="sub-status" key="act-sub-fil-sub-status"
                                            selection
                                            options={this.state.subStatus}
                                            value={this.state.currentStatusValue}
                                            text={this.state.currentStatusText}
                                            onChange={this.onStatusChange}
                                            ></Dropdown>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                            <Header>Markets</Header>
                                            <Dropdown fluid name="markets" key="act-sub-fil-markets"
                                            selection
                                            options={this.state.markets}
                                            value={this.state.currentMarketValue}
                                            text={this.state.currentMarketText}
                                            onChange={this.onMarketChange}></Dropdown>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                            <button className="button-submit">Search</button>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Formsy>
                        </Segment>
                        
                        
                        <Segment className={`content-segment visible}`}>
                            <Container fluid>
                                <Pagination ellipsisItem={null} totalPages={Math.ceil(this.state.saasMetricsCount / rowsPerPage)} activePage={this.state.page} onPageChange={this.onPageChange} />
                            </Container>
                            <Table celled striped sortable>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Email</Table.HeaderCell>
                                        <Table.HeaderCell>Business</Table.HeaderCell>
                                        <Table.HeaderCell>Phone</Table.HeaderCell>
                                        <Table.HeaderCell>Category</Table.HeaderCell>
                                        <Table.HeaderCell sorted={_.find(this.state.columnSort, x => x.column == 'lastConnected').direction} 
                                        onClick={() => this.onTableSort('lastConnected')}>Last Connected</Table.HeaderCell>
                                        <Table.HeaderCell sorted={_.find(this.state.columnSort, x => x.column == 'connect').direction} 
                                        onClick={() => this.onTableSort('connect')}>Connected</Table.HeaderCell>
                                        <Table.HeaderCell sorted={_.find(this.state.columnSort, x => x.column == 'images').direction} 
                                        onClick={() => this.onTableSort('images')}>Images</Table.HeaderCell> 
                                        <Table.HeaderCell sorted={_.find(this.state.columnSort, x => x.column == 'quoted').direction} 
                                        onClick={() => this.onTableSort('quoted')}>Quoted</Table.HeaderCell>     
                                        <Table.HeaderCell sorted={_.find(this.state.columnSort, x => x.column == 'booked').direction} 
                                        onClick={() => this.onTableSort('booked')}>Booked</Table.HeaderCell>  
                                        
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {
                                        this.state.saasMetrics.length > 0 &&
                                        _.map(this.state.saasMetrics, sub => {
                                            return <Table.Row>
                                                <Table.Cell className='email'>
                                                    {sub.email}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <span className={`${this.state.subscriptionSearchEnabled ? "seller-business-name" : ""} `} onClick={this.state.subscriptionSearchEnabled ? () => { this.handleSellerNameClick(sub.sellerID) } : () => { }} >
                                                        {sub.sellerName}
                                                    </span>
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.cellPhone}
                                                </Table.Cell>                                                                               
                                                <Table.Cell>
                                                    {sub.categoryName}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.lastConnected ? moment(sub.lastConnected).format("MM/DD/YYYY") : '-'}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.connect}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.images}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.quoted}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.booked}
                                                </Table.Cell>
                                            </Table.Row>
                                        })
                                    }
                                    {
                                        this.state.saasMetricsCount.length == 0 && <Table.Row>
                                            <Table.Cell colspan={16}>
                                                No record found
                                            </Table.Cell>
                                        </Table.Row>
                                    }
                                </Table.Body>
                            </Table>
                            <Container fluid>
                                <Pagination ellipsisItem={null} totalPages={Math.ceil(this.state.saasMetricsCount / rowsPerPage)}   activePage={this.state.page} onPageChange={this.onPageChange} />
                            </Container>
                        </Segment>
                        
                    </div>
                </div>
                
            </Dimmer.Dimmable>
        )
    }
}

export default SaasMetricsContainer
